<script>
export default {
  computed: {
    downloadConsoleAppLink() {
      const Android = navigator.userAgent.match(/Android/i)
      const iOS = navigator.userAgent.match(/iPhone|iPad|iPod/i)
      if (Android) {
        return 'https://play.google.com/store/apps/details?id=com.nhn.toast.console'
      } else if (iOS) {
        return 'https://itunes.apple.com/app/apple-store/id1454457828'
      }
      return ''
    }
  }
}
</script>
